var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWhatsapp = function SvgWhatsapp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1982",
    "data-name": "Ret\\xE2ngulo 1982",
    width: 21.311,
    height: 21.364,
    fill: "currentColor"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "open_in_new",
    transform: "translate(-119 -584)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_1981",
    "data-name": "Ret\\xE2ngulo 1981",
    width: 24,
    height: 24,
    transform: "translate(119 584)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6342",
    "data-name": "Grupo 6342",
    transform: "translate(120.344 585.317)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_6342-2",
    "data-name": "Grupo 6342",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8541",
    "data-name": "Caminho 8541",
    d: "M19.655,17.053a1.773,1.773,0,0,0-1.511-.34c-.392.16-.643.775-.9,1.089a.377.377,0,0,1-.487.105,6.846,6.846,0,0,1-3.415-2.926.419.419,0,0,1,.053-.572,2.306,2.306,0,0,0,.621-1.007,2.2,2.2,0,0,0-.278-1.192,2.824,2.824,0,0,0-.88-1.327,1.207,1.207,0,0,0-1.31.194,2.66,2.66,0,0,0-.922,2.107,3,3,0,0,0,.083.669,5.527,5.527,0,0,0,.641,1.478,11.736,11.736,0,0,0,.67,1.018,10.329,10.329,0,0,0,2.9,2.7,8.778,8.778,0,0,0,1.811.861,4.024,4.024,0,0,0,2.108.333,2.551,2.551,0,0,0,1.911-1.422,1.236,1.236,0,0,0,.089-.726c-.109-.5-.786-.8-1.19-1.039",
    transform: "translate(-4.97 -5.034)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8542",
    "data-name": "Caminho 8542",
    d: "M0,21.364l1.532-5.715a10.578,10.578,0,1,1,4.213,4.175Zm6.03-3.68.361.216a8.586,8.586,0,1,0-2.937-2.91l.222.364-.855,3.191Z",
    transform: "translate(0 0)",
    fill: "currentColor"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWhatsapp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/whatsapp.b4838f3f.svg";
export { ForwardRef as ReactComponent };